import { Center, Icon, Image, Spinner } from '@chakra-ui/react'
import { ReactElement, useState } from 'react'
import { MdOutlineBrokenImage } from 'react-icons/md'
import {
  extensionToIconMap,
  getExtensionFromURL,
} from '../../../utils/mediaLibrary'

const BrokenIcon = (
  <Center>
    <Icon as={MdOutlineBrokenImage} boxSize="100%" padding="10%" />
  </Center>
)

const AnalyticsFilePreview = ({
  url,
  forceimagePreview = false,
  thumbnailUrl,
}: {
  url: string
  forceimagePreview?: boolean
  thumbnailUrl?: string
}): ReactElement => {
  const [imageState, setImageState] = useState<'loading' | 'loaded' | 'error'>(
    'loading'
  )

  const onErrorHandler = () => {
    setImageState('error')
  }

  const onLoadedDataHandler = () => {
    setImageState('loaded')
  }

  const renderImage = () => {
    // Using this instead of fallback because the fallback is not working as expected for status code 403
    if (imageState === 'error') {
      return BrokenIcon
    }

    return (
      <>
        {imageState === 'loading' && (
          <Center>
            <Spinner />
          </Center>
        )}
        <Image
          src={thumbnailUrl || url}
          onLoad={onLoadedDataHandler}
          onError={onErrorHandler}

        />
      </>
    )
  }

  if (forceimagePreview) {
    return renderImage()
  }

  const extension = getExtensionFromURL(url)

  if (!extension) {
    return BrokenIcon
  }

  const isVideoJob = url.includes('ik-thumbnail')

  if (
    !isVideoJob &&
    ['jpg', 'webp', 'jpeg', 'png', 'gif', 'svg', 'avif'].includes(extension)
  ) {
    return renderImage()
  }

  const IconComponent = extensionToIconMap[extension] ?? null
  if (!IconComponent) {
    return BrokenIcon
  }

  return (
    <Center>
      <Icon as={IconComponent} boxSize="100%" padding="10%" />
    </Center>
  )
}

export default AnalyticsFilePreview
